module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("消防安全管理承诺书")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("        我是" + _vm._s(_vm.organization.name) + "（单位名称）的消防安全责任人，按照《中华人民共和国消防法》、《消防安全责任制实施办法》，为有效预防火灾事故发生，现就我单位消防安全工作作出以下几项承诺：（勾选）\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedAgreesChange
    },
    model: {
      value: (_vm.checkedAgreeTypes),
      callback: function($$v) {
        _vm.checkedAgreeTypes = $$v
      },
      expression: "checkedAgreeTypes"
    }
  }, _vm._l((_vm.dictAgreeTypes), function(dictAgreeType) {
    return _c('el-checkbox', {
      key: dictAgreeType.value,
      staticStyle: {
        "margin-left": "30px",
        "width": "700px"
      },
      attrs: {
        "label": dictAgreeType.value
      }
    }, [_vm._v(_vm._s(dictAgreeType.name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleAgree($event)
      }
    }
  }, [_vm._v("同意\n      ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "warning",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleDisAgree($event)
      }
    }
  }, [_vm._v("拒绝\n      ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e771f652"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Agree.vue
// module id = 1195
// module chunks = 2